export default "__VITE_PUBLIC_ASSET__edd18b4d__"